import { createContext } from 'react'

interface ISessionContext {
  ctok: string
  isAdmin: boolean
  feedbackPopUpOpenTimestamp: number
  accountName: string
  features: string[]
}

export const SessionContext = createContext<ISessionContext>({
  ctok: '',
  isAdmin: false,
  feedbackPopUpOpenTimestamp: 0,
  accountName: '',
  features: [],
})
